'use client';

import { classes } from '@/uiPrimitives/base/classes.helpers';
import { DetailsHTMLAttributes } from 'react';
import { useSelectedFilters } from './useSelectedFilters';
import { box } from '@/uiPrimitives/layout/box';
import { textBlock } from '@/uiPrimitives/typography/text';
import { translateInline } from '@/globals/translate/translateInline';
import { pluralize } from '@/globals/helpers/pluralize';

export const FilterDetails = ({
	groupKey: _groupKey,
	...props
}: {
	groupKey: string;
} & DetailsHTMLAttributes<HTMLDetailsElement>) => {
	return <details open {...props} />;
};

export const FilterSelectedOptionCount = ({
	groupKey,
	className,
}: {
	groupKey: string;
	className?: string;
}) => {
	const [selectedFilters] = useSelectedFilters();
	const count = selectedFilters.get(groupKey)?.size ?? 0;

	if (count === 0) {
		return null;
	}

	const resultCountText = pluralize(count, {
		none: translateInline({
			en: `No filters selected  `,
			nl: `Geen filters geselecteerd`,
		}),
		single: translateInline({
			en: `${count} selected filter`,
			nl: `${count} geselecteerde filter`,
		}),
		plural: translateInline({
			en: `${count} selected filters`,
			nl: `${count} geselecteerde filters`,
		}),
	});

	return (
		<span
			aria-label={resultCountText}
			className={classes(
				className,
				box({
					borderRadius: 'circle',
					backgroundColor: 'positiveBlue',
					inlineSize: '2 | h2',
					blockSize: '2 | h2',
				}),
				textBlock({
					capLineHeight: 'tight',
					capSize: '-2 | smaller',
					fontVariantNumeric: 'lining-nums',
					textAlign: 'center',
					verticalAlign: 'middle',
				}),
			)}
		>
			{count}
		</span>
	);
};
